import React, { useState, useEffect } from "react";
import { classNames } from "src/helpers/classNames";
import PreloaderIcon from "src/components/shared/LoadingAnimations/PreloaderIcon";

const RefreshTimer = ({ timeframe = 1, onRefresh, isRefreshing, enabled = false }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(timeframe * 60);
  const [showCountdown, setShowCountdown] = useState(false);

  useEffect(() => {
    if (!enabled || timeframe < 1) {
      setShowCountdown(false);
      return;
    }

    const totalSeconds = timeframe * 60;
    setSecondsRemaining(totalSeconds);
    setShowCountdown(false);

    const timer = setInterval(() => {
      setSecondsRemaining((prev) => {
        const nextValue = prev - 1;

        if (nextValue <= 5 && nextValue > 0) {
          setShowCountdown(true);
        }

        if (nextValue <= 0) {
          setShowCountdown(false);
          onRefresh(null, true);
          return totalSeconds;
        }

        return nextValue;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [enabled, timeframe, onRefresh]);

  return (
    <div
      className={classNames(
        "fixed bottom-4 right-4 z-50 flex items-center gap-x-3 rounded-xl border border-gray-100 bg-white px-4 py-2.5 shadow-2xl transition-all duration-500",
        showCountdown || isRefreshing ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-12 opacity-0",
      )}>
      <div className="flex items-center gap-x-2.5">
        {isRefreshing ? (
          <>
            <PreloaderIcon
              height="h-4"
              width="w-4"
              color="text-gray-100 fill-highlightColor"
            />
            <span className="text-xs font-medium text-gray-600">Refreshing...</span>
          </>
        ) : (
          <>
            <div className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-highlightColor opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-highlightColor"></span>
            </div>
            <span className="text-xs font-medium text-gray-600">
              Refreshing in <span className="font-semibold tabular-nums text-highlightColor">{secondsRemaining}s</span>
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(RefreshTimer);
